import React from "react";
import { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { Col, Row } from "reactstrap";
import { useMediaQuery } from "react-responsive";
import { APILA } from "../../../../../config/apila";
import { APIMS } from "../../../../../config/apims";
import { faRectangleList } from '@fortawesome/free-solid-svg-icons';
import "bulma/css/bulma.css";
import "../../../../../index.css";
import swal from "sweetalert";
import { useLocation, useNavigate, Link } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import ToastError from "../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../NotificationToast/ToastSuccess";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ClipLoader, PulseLoader} from "react-spinners";
import ModalLeger from './modal/legerTeacher';

/* ===========================
   🔥 SKELETON SHIMMER STYLE
=========================== */
const shimmerStyle = `
  @keyframes shimmer {
    0% { background-position: -468px 0; }
    100% { background-position: 468px 0; }
  }
  .shimmer {
    animation-duration: 1.2s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-name: shimmer;
    background: #f6f7f8;
    background: linear-gradient(
      to right,
      #ddeaffff 8%,
      #f4f8ffff 18%,
      #ddeaffff 33%
    );
    background-size: 800px 104px;
  }
  .shimmer-select {
    height: 35px;
    border-radius: 4px;
  }
  .shimmer-row {
    height: 38px;
  }


  // .at-search{ min-width: 280px; }
  // .at-input{
  //   width:100%;
  //   height: 38px;
  //   border:1px solid #280095;
  //   border-radius: 10px;
  //   padding: 0 12px;
  //   font-size: 13px;
  //   outline:none;
  // }
  // .at-input:focus, .at-select:focus{
  //   border-color:#94a3b8;
  //   box-shadow: 0 0 0 3px rgba(148,163,184,0.25);
  // }
    
  `;



export default function Dimensi() {
  document.title = "Leger";

  const [savingId, setSavingId] = useState(null);

  const [page] = useState(1);
  const [limit] = useState(1000);
  const [ascending] = useState(1);
  const [descending] = useState(0);
  const [keyword] = useState("");
  const token = localStorage.getItem("token");

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 780px)" });
  const [loading, setLoading] = useState(false);
  const firstLoadDone = useRef(false);

  const storageBranchGroping = localStorage.getItem("ysb_branch_id");
  const storageLevel = localStorage.getItem("level");
  const storageSchoolId = localStorage.getItem('ysb_school_id');
  const storageTeacher = localStorage.getItem('teacherID');
  const storageBranch = localStorage.getItem('ysb_branch_id');
  
  // Data master
  const [getDataDimensi, setGetDataDimensi] = useState([]);
  const [getDataSemesterMap, setGetDataSemesterMap] = useState([]);

  // Table data
  const [getData, setGetData] = useState([]);

  // UI state
  const [hasSearched, setHasSearched] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [isFilterDirty, setIsFilterDirty] = useState(false);
  const [selectedTab, setSelectedTab] = useState(null);
  const [isFetching, setIsFetching] = useState(false);

  const [searchMap, setSearchMap] = useState({});

  const [namaTA, setNamaTA] = useState("");
  const [namaSmstr, setNamaSmstr] = useState("");

  // Filter form
  const [form2, setForm2] = useState({
    ysb_semester_id: "",
    ysb_dimensi_id: "",
    ysb_branch_id: "",
    ysb_school_id: "",
    ysb_teacher_id: "",
  });

  // EDIT nilai
  const [form3, setForm3] = useState({
    ysb_element_recap_id_id: "",
    ysb_sub_element_value: "",
  });

  const [updateId, setUpdateID] = useState(null);
  const id_user = localStorage.getItem("id_admin") || "";
  const output_id_user = id_user.replace(/[|&;$%@"<>()+,]/g, "");

  // Permission
  const location = useLocation();
  const [permission, setPermission] = useState({
    create: 0,
    read: 0,
    update: 0,
    delete: 0,
  });
  const navigate = useNavigate();

  useEffect(() => {
    const level = localStorage.getItem("level");
    const storageItems = JSON.parse(localStorage.getItem("role_permission")) || [];
    if (level === "developer" || level === "superadmin") {
      setPermission({ create: 1, read: 1, update: 1, delete: 1 });
      return;
    }
    const foundPermission = storageItems.find((item) => item.menu?.url === location.pathname);
    if (!foundPermission) navigate("/dashboard");
    else {
      setPermission({
        create: foundPermission.create,
        read: foundPermission.read,
        update: foundPermission.update,
        delete: foundPermission.delete,
      });
    }
  }, [location.pathname, navigate]);

  /* API HEADERS */
  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  // ---------- helper refs ----------
  const isMounted = useRef(true);
  const abortControllers = useRef([]);

  useEffect(() => {
    return () => {
      isMounted.current = false;
      abortControllers.current.forEach((c) => c.abort());
    };
  }, []);

  const safeStr = (v) => (v === null || v === undefined ? "" : String(v));

  // =========================
  // INIT: Semester + Dimensi
  // =========================
  const fetchInit = useCallback(async () => {
    setLoading(true);
    const controller = new AbortController();
    abortControllers.current.push(controller);

    try {
      const [semesterRes, dimensiRes] = await Promise.all([
        // APILA.get(
        //   `/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,
        //   { ...fetchParams, signal: controller.signal }
        // ),
        APIMS.get(
          `/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,
          { ...fetchParams, signal: controller.signal }
        ),
        APILA.get(
          `/api/access/dimensis?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}`,
          { ...fetchParams, signal: controller.signal }
        ),
      ]);

      if (!isMounted.current) return;

      // Semester aktif
      if (semesterRes?.status === 200) {
        const semesters = semesterRes.data.data || [];
        const active = semesters.find((s) => s.status === 1) || semesters[0];
        setGetDataSemesterMap(semesters);
        if (active) {
          setNamaTA(active.name_year || "");
          setNamaSmstr(active.semester || "");
          setForm2((prev) => ({ ...prev, ysb_semester_id: active.id }));
        }
      }

      // Dimensi aktif pertama
      if (dimensiRes?.status === 200) {
        const dims = (dimensiRes.data.data || []).filter((d) => d.status === 1);
        setGetDataDimensi(dims);
        if (dims.length > 0) setForm2((prev) => ({ ...prev, ysb_dimensi_id: dims[0].id }));
      }
    } catch (err) {
      swal({
        title: "Failed",
        text: err?.response?.data?.message || err.message || "Error",
        icon: "error",
      });
    } finally {
        setLoading(false);  
    }
  }, [ascending, descending, fetchParams, keyword, limit, page, storageBranchGroping, storageLevel]);

  useEffect(() => {
    fetchInit();
  }, [fetchInit]);


  // =========================
  // Filter complete
  // =========================
  const isFilterComplete =
    isFilterDirty &&
    !!form2.ysb_semester_id &&
    !!form2.ysb_dimensi_id;

  // =========================
  // Fetch table data
  // =========================
  const GetResponseData = useCallback(async () => {
  if (
    !form2.ysb_semester_id ||
    !form2.ysb_dimensi_id
  ) return;

  const params = {

     ysb_semester_id: form2?.ysb_semester_id,
          level: storageLevel,
          branch: storageBranch,
          ysb_dimensi_id: form2?.ysb_dimensi_id,
          ysb_school_id: storageSchoolId,
          ysb_teacher_id: storageTeacher
  };

  try {
    const response = await APILA.get(
      "/api/leger-recaps-teacher/teacher",
      {
        params,
        ...fetchParams,
      }
    );

    if (response?.status === 200) {
      setGetData(response.data.data || []);
    }
  } catch (error) {
    swal({
      title: "Gagal",
      text: error?.response?.data?.message || "Gagal mengambil data",
      icon: "error",
    });
  }
}, [form2, fetchParams, storageLevel]);

  // =========================
  // CLIENT-SIDE SEARCH (per element/tab)
  // =========================
  const filteredRekapanMap = useMemo(() => {
    const elements = getData?.[0]?.data_element || [];
    const out = {};

    const sortByNameAsc = (arr) =>
      [...(arr || [])].sort((a, b) => {
        const an = (a?.name_student || "").toString().toLowerCase();
        const bn = (b?.name_student || "").toString().toLowerCase();
        return an.localeCompare(bn, "id", { sensitivity: "base" });
      });

    elements.forEach((el) => {
      const qRaw = (searchMap?.[el?.id] || "").toString().trim().toLowerCase();
      const rows = el?.rekapan || [];

      if (!qRaw) {
        out[el?.id] = sortByNameAsc(rows);
        return;
      }

      const filtered = rows.filter((r) => {
        const name = (r?.name_student || "").toString().toLowerCase();
        const nisn = (r?.nisn ?? "").toString().toLowerCase();
        return name.includes(qRaw) || nisn.includes(qRaw);
      });

      out[el?.id] = sortByNameAsc(filtered);
    });

    return out;
  }, [getData, searchMap]);



  // AUTO SELECT TAB
  useEffect(() => {
    if (getData.length > 0 && getData[0]?.data_element?.length > 0 && !selectedTab) {
      setSelectedTab(getData[0].data_element[0].name_element);
    }
  }, [getData, selectedTab]);

  // FIRST LOAD
  useEffect(() => {
    if (
      firstLoadDone.current ||
      !form2.ysb_semester_id ||
      !form2.ysb_dimensi_id
    ) return;
  
    firstLoadDone.current = true;
  
    (async () => {
      setIsFetching(true);
      await GetResponseData(); 
      setHasSearched(true);
      setIsFirstLoad(false);
      setIsFilterDirty(false);
      setIsFetching(false);
    })();
  
  }, [
    form2.ysb_semester_id,
    form2.ysb_dimensi_id
  ]);

  // Reset tab kalau filter berubah
  useEffect(() => {
    setSelectedTab(null);
  }, [
    form2.ysb_semester_id,
    form2.ysb_dimensi_id
  ]);

  // =========================
  // HANDLER perubahan filter
  // =========================
  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm2((prev) => ({ ...prev, [name]: value }));

    if (!isFirstLoad) {
      setIsFilterDirty(true);
      setHasSearched(false);
    }
  };


  // =========================
  // BUTTON CARI
  // =========================
  const handleCari = async () => {
    if (!form2.ysb_semester_id ||  !form2.ysb_dimensi_id ) {
      swal({
        title: "Filter belum lengkap",
        text: "Pastikan Semester dan Dimensi sudah dipilih.",
        icon: "warning",
      });
      return;
    }

    setSelectedTab(null);
    setGetData([]);
    setSearchMap({});
    setHasSearched(false);
    setIsFetching(true);

    try {
      await GetResponseData();
      setHasSearched(true);
      setIsFilterDirty(false);
    } catch (err) {
      swal({
        title: "Failed",
        text: err?.response?.data?.message || "Terjadi kesalahan",
        icon: "error",
      });
    } finally {
      setIsFetching(false);
    }
  };

  const [showModal, setShowModal] = useState(false);
  const [dataModal, setDataModal] = useState(null);

  const handleOpenModal = (element, rekap) => {
    setDataModal({
        name_element: element?.name_element,
        description: element?.description,
        kkca_description: rekap?.kkca_description,
        name_student: rekap?.name_student,
        nisn: rekap?.nisn,

        ysb_dimensi_id: element?.ysb_dimensi_id,
        ysb_element_id: element?.id,
        ysb_semester_id: rekap?.ysb_semester_id,
        ysb_school_id: rekap?.ysb_school_id,
        ysb_branch_id: rekap?.ysb_branch_id,

        ysb_teacher_id: rekap?.ysb_teacher_id,

        ysb_student_id: rekap?.ysb_student_id,
        ysb_kelas_id: rekap?.ysb_kelas_id,
        ysb_element_recap_id: rekap?.ysb_element_recap_id,

        sub_elements: rekap?.sub_elements || [],
    });
    setShowModal(true);
  };

  const handleModalSaved = useCallback((payload) => {
      if (!payload) return;
  
      const recapId = payload?.ysb_element_recap_id;
      if (!recapId) return;
  
      // update dataModal supaya saat buka modal lagi sudah membawa data terbaru
      setDataModal((prev) => {
        if (!prev) return prev;
        if (prev?.ysb_element_recap_id !== recapId) return prev;
        return {
          ...prev,
          sub_elements: payload?.sub_elements ?? prev.sub_elements,
          average: payload?.average ?? prev.average,
          kkca_description: payload?.kkca_description ?? prev.kkca_description,
          kkca_description_full: payload?.kkca_description_full ?? prev.kkca_description_full,
        };
      });
  
      // update table data
      setGetData((prev) => {
        const root = Array.isArray(prev) ? prev : [];
        if (!root.length) return prev;
  
        return root.map((group) => {
          const dataEl = Array.isArray(group?.data_element) ? group.data_element : [];
          const nextDataEl = dataEl.map((el) => {
            const rekapan = Array.isArray(el?.rekapan) ? el.rekapan : [];
            const nextRekapan = rekapan.map((r) => {
              if (r?.ysb_element_recap_id !== recapId) return r;
              return {
                ...r,
                average: payload?.average ?? r.average,
                kkca_description: payload?.kkca_description ?? r.kkca_description,
                kkca_description_full: payload?.kkca_description_full ?? r.kkca_description_full,
                sub_elements: payload?.sub_elements ?? r.sub_elements,
              };
            });
            return { ...el, rekapan: nextRekapan };
          });
  
          return { ...group, data_element: nextDataEl };
        });
      });
    }, []);

  const toTitleCase = (value) => {
    const s = safeStr(value).toLowerCase().trim();
    if (!s) return "";
    return s.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1));
  };

   return (
    <>
      <style>{shimmerStyle}</style>

      <div className="body" >

        <div className="page-header-card">
         {isTabletOrMobile ? (
          <>
            <div className="page-header-top d-flex">
              <div className="page-title-wrap">
                <span className="page-title-icon">
                  <FontAwesomeIcon icon={faRectangleList} />
                  </span>
                <h4 className="page-title-text"> Leger</h4>
              </div>
            </div>

             <nav aria-label="breadcrumb" className="custom-breadcrumb-nav mt-4">
              <ol className="custom-breadcrumb">
                <li className="custom-breadcrumb-item">
                  <Link to="/dashboards-teacher">Beranda</Link>
                </li>
                <li className="custom-breadcrumb-separator">/</li>
                <li
                  className="custom-breadcrumb-item active"
                  aria-current="page"
                >
                  Leger
                </li>
              </ol>
            </nav>
          </>
          ) : (
          <>
            <div className="page-header-top d-flex">
              <div className="page-title-wrap">
                <span className="page-title-icon">
                  <FontAwesomeIcon icon={faRectangleList} />
                </span>
                <h4 className="page-title-text"> Leger</h4>
              </div>
            </div>

            <nav aria-label="breadcrumb" className="custom-breadcrumb-nav mt-4">
              <ol className="custom-breadcrumb">
                <li className="custom-breadcrumb-item">
                  <Link to="/dashboards-teacher">Beranda</Link>
                </li>
                <li className="custom-breadcrumb-separator">/</li>
                <li
                  className="custom-breadcrumb-item active"
                  aria-current="page"
                >
                  Leger
                </li>
              </ol>
            </nav>
          </>
         )}
      </div>

        <div className="body-content">
        
          {/* FILTER */}
          {isTabletOrMobile ? (
            <div className="title-page">
              <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                <select
                  className="mr-2"
                  name="ysb_semester_id"
                  value={form2.ysb_semester_id}
                  onChange={handleChange}
                  style={{
                    border: "1px solid #d9defa",
                    borderRadius: "12px",
                    fontSize: "14px",
                    padding: "10px 12px",
                    background: "#fff",
                  }}
                >
                  <option value="" hidden>
                    {namaTA} (Semester {namaSmstr})
                  </option>
                  {getDataSemesterMap.map((user, index) => (
                    <option key={index} value={user?.id}>
                      {user?.name_year} (Semester {user?.semester})
                    </option>
                  ))}
                </select>
              </Row>

              <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                <select
                  className="mr-2"
                  name="ysb_dimensi_id"
                  value={form2.ysb_dimensi_id}
                  onChange={handleChange}
                  style={{
                    border: "1px solid #d9defa",
                    borderRadius: "12px",
                    fontSize: "14px",
                    padding: "10px 12px",
                    background: "#fff",
                  }}
                >
                  <option value="" hidden>
                    Pilih Dimensi
                  </option>
                  {getDataDimensi.map((user, index) => (
                    <option key={index} value={user?.id}>
                      {user?.name_dimensi}
                    </option>
                  ))}
                </select>
              </Row>

              <Row style={{ marginTop: "12px", padding: "0 12px" }}>
                <button
                  onClick={handleCari}
                  disabled={!isFilterComplete}
                  className="btn"
                  style={{
                    fontSize: "13px",
                    padding: "10px 16px",
                    borderRadius: "12px",
                    backgroundColor: !isFilterComplete ? "#c9c9c9" : "#eca91aff",
                    color: "#fff",
                    cursor: !isFilterComplete ? "not-allowed" : "pointer",
                  }}
                >
                  Cari
                </button>
              </Row>
            </div>
          ) : (
            <>
              <div className="mb-3">
                {loading ? (
                  <>
                    <div className="mb-3 d-flex">
                      <div className="shimmer shimmer-select mr-2" style={{width:180, borderRadius: "12px"}} />
                      <div className="shimmer shimmer-select mr-2" style={{width:220, borderRadius: "12px"}} />
                      <div className="shimmer shimmer-select mr-2" style={{width:70, borderRadius: "12px"}} />
                    </div>
                  </>
                ) : (
                    <div className="mb-3 mt-1">
                      <div className="d-flex">
                        <select
                          className="mr-2"
                          name="ysb_semester_id"
                          value={form2.ysb_semester_id}
                          onChange={handleChange}
                           style={{
                            border: "1px solid #d9defa",
                            borderRadius: "12px",
                            fontSize: "14px",
                            padding: "10px 12px",
                            background: "#fff",
                          }}
                        >
                          <option value="" hidden>
                            {namaTA} (Semester {namaSmstr})
                          </option>
                          {getDataSemesterMap.map((user, index) => (
                            <option key={index} value={user?.id}>
                              {user?.name_year} (Semester {user?.semester})
                            </option>
                          ))}
                        </select>

                        <select
                          className="mr-2"
                          name="ysb_dimensi_id"
                          value={form2.ysb_dimensi_id}
                          onChange={handleChange}
                           style={{
                            border: "1px solid #d9defa",
                            borderRadius: "12px",
                            fontSize: "14px",
                            padding: "10px 12px",
                            background: "#fff",
                          }}
                        >
                          <option value="" hidden>
                            Pilih Dimensi
                          </option>
                          {getDataDimensi.map((user, index) => (
                            <option key={index} value={user?.id}>
                              {user?.name_dimensi}
                            </option>
                          ))}
                        </select>

                        <button
                          onClick={handleCari}
                          disabled={!isFilterComplete}
                          className="btn"
                          style={{
                            fontSize: "13px",
                            padding: "10px 16px",
                            borderRadius: "12px",
                            backgroundColor: !isFilterComplete ? "#c9c9c9" : "#eca91aff",
                            color: "#fff",
                            cursor: !isFilterComplete ? "not-allowed" : "pointer",
                          }}
                        >
                          Cari
                        </button>

                      </div>
                    </div>
                )
              }
              </div>
              
            </>           
          )}

          {isFetching && (
              <div className="text-center" style={{ padding: "10px 0" }}>
                <span style={{color: "#2e52aeff", fontWeight: "500"}}><PulseLoader color={'#3f5bea'} size={12}/></span>
              </div>
          )}

          {hasSearched && !isFetching && (
              <Tabs id="uncontrolled-tab-example" activeKey={selectedTab} onSelect={(k) => setSelectedTab(k)} className="mb-3 mt-4 nav-tabs">
                  {(getData?.[0]?.data_element || []).map((element, eIdx) => (
                      <Tab key={element?.id || eIdx} eventKey={element?.name_element} title={element?.name_element} className="nav-item">
                        <div className="text-center" style={{ marginTop: "10px", marginBottom: "20px", backgroundColor: "#9fd5ffff", padding: "5px 0px" }}>
                          <h5 className="mt-2 mb-2">{element?.description}</h5>
                        </div>

                        <div className="mt-3">
                            <div className="at-search">
                              <input
                                className="at-input"
                                placeholder="Cari Siswa / NISN"
                                value={searchMap[element?.id] || ""}
                                onChange={(e) =>
                                  setSearchMap((prev) => ({
                                    ...prev,
                                    [element?.id]: e.target.value,
                                  }))
                                }
                              />
                            </div>
                          </div>

                          <Col xl="12" sm="12">
                            <div className="mt-3">
                              <div className="body-table">
                                <div className="">
                                  <table className="table table-laporan-adab table-hover table-bordered" id="basic-datatable">
                                    <thead>
                                      <tr>
                                          <th style={{textAlign: "center", border: "1px solid #e0e0e0ff", width: "60px"}}>No</th>
                                <th style={{textAlign: "center", border: "1px solid #e0e0e0ff"}}>Nama</th>
                                          <th style={{textAlign: "center", border: "1px solid #e0e0e0ff"}}>Nisn</th>
                                          <th style={{textAlign: "center", border: "1px solid #e0e0e0ff"}}>Nilai</th>
                                          <th style={{textAlign: "center", border: "1px solid #e0e0e0ff"}}>KKCA</th>
                                          <th style={{textAlign: "center", border: "1px solid #e0e0e0ff"}}>Deskripsi</th>
                                      </tr>
                                    </thead>
          
                                    <tbody>
                                      {(filteredRekapanMap[element?.id] || []).map((rekap, rowIndex) => (
                                        <tr key={rekap?.ysb_element_recap_id}>
                                          <td style={{ lineHeight: "2", textAlign: "center" }}>{rowIndex + 1}</td>
                                          
                                          <td
                                            style={{ cursor: "pointer", color: "#0d6efd", fontWeight: "600", fontSize: "14px" }}
                                            onClick={() => handleOpenModal(element, rekap)}
                                          >
                                            {toTitleCase(rekap?.name_student)}
                                          </td>

                                          <td style={{ lineHeight: "2", textAlign: "center" }}>{rekap?.nisn}</td>
                                          
                                          <td style={{ lineHeight: "2", textAlign: "center" }}>
                                            {rekap?.average}
                                            
                                          </td>
                                          <td style={{ lineHeight: "2", textAlign: "center" }}>{rekap?.kkca_description}</td>
                                          <td style={{ lineHeight: "2", textAlign: "center" }}>{rekap?.kkca_description_full}</td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </Col>
          
                        
          
                        <ModalLeger
                          show={showModal}
                          onHide={() => setShowModal(false)}
                          data_leger={dataModal}
                          onSaved={handleModalSaved}
                        />
                      </Tab>
                  ))}
              </Tabs>
          )}

        </div>
      </div>
    </>
  );
}
